// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * LCC API
 * API for the LCC backend
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UALADSFunctionalUnitLock
 */
export interface UALADSFunctionalUnitLock {
    /**
     * 
     */
    locked?: boolean;
    /**
     * 
     */
    lockingClient?: string;
    /**
     * 
     */
    lockingUser?: string;
    /**
     * 
     */
    remainingLockTime?: number;
}

/**
 * Check if a given object implements the UALADSFunctionalUnitLock interface.
 */
export function instanceOfUALADSFunctionalUnitLock(value: object): value is UALADSFunctionalUnitLock {
    return true;
}

export function UALADSFunctionalUnitLockFromJSON(json: any): UALADSFunctionalUnitLock {
    return UALADSFunctionalUnitLockFromJSONTyped(json, false);
}

export function UALADSFunctionalUnitLockFromJSONTyped(json: any, ignoreDiscriminator: boolean): UALADSFunctionalUnitLock {
    if (json == null) {
        return json;
    }
    return {
        
        'locked': json['locked'] == null ? undefined : json['locked'],
        'lockingClient': json['lockingClient'] == null ? undefined : json['lockingClient'],
        'lockingUser': json['lockingUser'] == null ? undefined : json['lockingUser'],
        'remainingLockTime': json['remainingLockTime'] == null ? undefined : json['remainingLockTime'],
    };
}

export function UALADSFunctionalUnitLockToJSON(json: any): UALADSFunctionalUnitLock {
    return UALADSFunctionalUnitLockToJSONTyped(json, false);
}

export function UALADSFunctionalUnitLockToJSONTyped(value?: UALADSFunctionalUnitLock | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'locked': value['locked'],
        'lockingClient': value['lockingClient'],
        'lockingUser': value['lockingUser'],
        'remainingLockTime': value['remainingLockTime'],
    };
}

